module.exports = {"illu_01":"illu_en_01.png","illu_02":"illu_en_02.png","illu_03":"illu_en_03.png","illu_04":"illu_en_04.png","illu_05":"illu_en_05.png"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/jumbotron.json
// module id = qTro
// module chunks = 1